import { memo } from 'react'
import styled from 'styled-components'
import { SystemIcon, Toggle, Button } from 'components'
import { Typography } from '@astro-ui/components'

function RowUom({ data, rbacPermission, handleChangeStatus, handleEdit, handleClickDetail }) {
  return (
    <Tr>
      <Td ratio="2">
        <Typography sx={{ fontWeight: 300, color: '#525a67' }}>{data.id}</Typography>
      </Td>
      <Td ratio="2">
        <Typography sx={{ fontWeight: 300, color: '#525a67' }}>{data.group}</Typography>
      </Td>
      <Td ratio="2">
        <Typography sx={{ fontWeight: 300, color: '#525a67' }}>{data.description}</Typography>
      </Td>

      <Td ratio="1">
        {rbacPermission.isAllowedForBtnToggleStatus && (
          <Toggle onClick={() => handleChangeStatus(data)} active={data.active} />
        )}
      </Td>
      <Td ratio="1">
        <ActionWrapper>
          <Button variant="wrapper" onClick={() => handleClickDetail(data)}>
            <Typography sx={{ fontWeight: 300, cursor: 'pointer', color: '#246ee5' }}>
              Detail
            </Typography>
          </Button>
          {rbacPermission.isAllowedForBtnUpdateUom && (
            <Button variant="wrapper" onClick={() => handleEdit(data)}>
              <SystemIcon className="pointer" colorIcon="main" iconName="edit" />
            </Button>
          )}
        </ActionWrapper>
      </Td>
    </Tr>
  )
}

export default memo(RowUom)

const Tr = styled.tr`
  display: flex;
  padding: 12px 32px;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-bottom: 1px solid #f3f6fa;
  align-items: center;
`
const Td = styled.td`
  color: ${({ theme: { colors } }) => colors.grey};
  /* font-weight: ${({ theme: { fontWeights } }) => fontWeights.light}; */
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  flex: ${({ ratio }) => ratio};
  text-align: start;
`

const ActionWrapper = styled.div`
  display: flex;
  i {
    margin-left: 20px;
  }
`
